import React from 'react'
import * as Styled from './ServiceInformationDefaultMessage.styles'

const ServiceInformationDefaultMessage = () => (
  <>
    <Styled.Heading>Out with the old, in with the new</Styled.Heading>
    <Styled.Paragraph>
      Here at Argos we don't just recycle old jokes - we also recycle old products. So when your new product is
      delivered, we’ll take away your old item to be recycled, along with any excess packaging. Simple.
    </Styled.Paragraph>
    <strong>Installation</strong>
    <Styled.Paragraph>
      Not only will we take it away for you, we’ll install it too – we have qualified tradespeople on standby to help
      get you up and running.
    </Styled.Paragraph>
    <strong>Disconnection</strong>
    <Styled.Paragraph>
      If it’s an integrated appliance, or any type of cooker, we’ll also disconnect your old appliance as part of the
      service.
    </Styled.Paragraph>
    <Styled.Paragraph>
      <a href='https://www.argos.co.uk/help/faq/72487'>
        Find out which products are eligible for recycling and installation.
      </a>
    </Styled.Paragraph>
    <Styled.Heading>Important things to know</Styled.Heading>
    <Styled.List>
      <Styled.ListItem>
        After you’ve placed your order, you’ll get a call within 48hrs to book a delivery/ installation date that suits
        you. On your selected day, you’ll receive a text message to confirm the four-hour window when the installation
        team arrive. We’ll call again to let you know when we’re actually en-route to your property.
      </Styled.ListItem>
      <Styled.ListItem>
        If you select our ‘recycling only’ service, or your appliance is freestanding, you must disconnect, defrost and
        empty your old appliance of any water first. If this isn't done, we simply won't be able to collect it.
      </Styled.ListItem>
      <Styled.ListItem>
        For integrated appliances, and all types of cookers, we’ll disconnect your old one as part of the installation
        service.
      </Styled.ListItem>
      <Styled.ListItem>
        If you opt for installation, our installation team will deliver and install your new product all in one visit.
      </Styled.ListItem>
    </Styled.List>
    <Styled.Paragraph>
      <a href='https://www.argos.co.uk/help/faq/index.php?action=artikel&id=72459&artlang=en'>
        The finer details about installation and recycling.
      </a>
    </Styled.Paragraph>
  </>
)

export default ServiceInformationDefaultMessage
